/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';
import { navigation } from 'modules/me/controller';

export default (router) => {
	router(`/me/preferences`,navigation, controller.index, makeLayout, render);
};
